import React from "react";
import { Separator } from "./ui/separator";

const Footer = () => {
  return (
    <footer className="bg-black py-12 border-t border-yellow-500/20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo and Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/w77kfm85_Mining-Logo.svg" 
                alt="Kitco Mining" 
                className="h-6"
                onError={(e) => {
                  // Fallback if SVG fails to load
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="hidden items-center space-x-2">
                <div className="bg-yellow-500 text-black px-3 py-1 font-bold text-lg rounded">
                  KITCO
                </div>
                <span className="text-yellow-500 font-semibold">MINING</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              The leader in mining coverage, connecting the global mining community 
              with trusted news, analysis, and advertising solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <div className="space-y-2">
              <a href="#services" className="block text-gray-400 hover:text-yellow-500 transition-colors text-sm">
                Services
              </a>
              <a href="#audiences" className="block text-gray-400 hover:text-yellow-500 transition-colors text-sm">
                Audiences
              </a>
              <a href="#clients" className="block text-gray-400 hover:text-yellow-500 transition-colors text-sm">
                Clients
              </a>
              <a href="#contact" className="block text-gray-400 hover:text-yellow-500 transition-colors text-sm">
                Contact
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="space-y-2 text-sm">
              <p className="text-gray-400">
                620 Cathcart Street, Suite 900<br />
                Montreal, Quebec H3B 1M1
              </p>
              <p className="text-gray-400">
                Phone: 1 855 585-4826<br />
                Local: 514 627-4120
              </p>
              <p className="text-gray-400">
                Email: <span data-email="advertising" data-domain="kitco.com" className="email-obfuscated cursor-pointer hover:text-yellow-500 transition-colors">Click to reveal email</span>
              </p>
            </div>
          </div>
        </div>

        <Separator className="bg-yellow-500/20 mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2025 Kitco Metals Inc. All rights reserved.
          </div>
          
          <div className="flex space-x-6 text-sm">
            <a href="https://www.kitco.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
              Privacy Policy
            </a>
            <a href="https://www.kitco.com/legal/terms-and-conditions" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
              Terms and Conditions
            </a>
            <a href="https://www.kitco.com/terms-of-use" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-yellow-500 transition-colors">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;